// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__6HUyW","title":"style_title__T2qAT","description":"style_description__zoPWq","actions":"style_actions__h7zJO","actions_btn":"style_actions_btn__ios6x"};